module.exports = __webpack_public_path__ + "img/kimi.ddb052dc.png";